import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AddTaskFile, EditTaskFile, TaskFileParams, TaskFileWithPage } from '@app/interfaces/lm/task';
import { environment } from '@env/environment';
import { BaseStationEdit } from '@app/interfaces/rm/base-station';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class TaskFileService {
    private moduleApi = environment.api.services.lm;
    private baseUrl = this.moduleApi;

    constructor(private http: HttpClient) {
    }

    async find(params: TaskFileParams): Promise<TaskFileWithPage> {
        return lastValueFrom(this.http.get<TaskFileWithPage>(`${this.baseUrl}/task-files`, {
            params: Object.assign(params),
        }));
    }

    async add(data: AddTaskFile): Promise<void> {
        return lastValueFrom(this.http.post<void>(`${this.baseUrl}/task-file`, data));
    }

    async remove(params: { id: string }): Promise<void> {
        return lastValueFrom(this.http.delete<void>(`${this.baseUrl}/task-file`, {
            params: Object.assign(params)
        }));
    }

    async edit(option: EditTaskFile): Promise<void> {
        return lastValueFrom(this.http.put<void>(`${this.baseUrl}/task-file`, option));
    }
}
